import React from 'react'
import { HubspotSyncChangesModal } from './HubspotSyncChangesModal'
import { AccessGrantResultsModal } from './AccessGrantResultsModal'
import { HubspotSyncModal } from './HubspotSyncModal'
import { HubspotSyncNewCompaniesModal } from './HubspotSyncNewCompaniesModal'
import { HubspotSyncReviewCard } from './HubspotSyncReviewCard'
import { HubspotSyncTaskBanner } from './HubspotSyncTaskBanner'
import type { HubspotSyncFlowState } from './useHubspotSync'

interface HubspotSyncFlowProps {
  state: HubspotSyncFlowState
}

/**
 * Everything a sync puts on screen: the confirm and progress modal, the banner
 * of what it left behind, the recipients it wants reviewed, and whichever task
 * modal the banner has open.
 */
const HubspotSyncFlow = ({ state }: HubspotSyncFlowProps) => (
  <>
    <HubspotSyncModal
      open={state.isSyncModalOpen}
      isRunning={state.run.phase === 'running'}
      onStart={state.handleStartSync}
      onCancel={state.handleCancelSync}
    />

    {state.isBannerVisible ? (
      <HubspotSyncTaskBanner
        heading={state.run.heading}
        tasks={state.run.tasks}
        onOpenTask={state.handleOpenTask}
        onDismiss={state.handleDismissBanner}
      />
    ) : null}

    <HubspotSyncNewCompaniesModal
      open={state.openTask === 'new'}
      state={state.newCompanies}
      onClose={state.handleCloseTask}
    />
    <HubspotSyncChangesModal
      open={state.openTask === 'changes'}
      state={state.changes}
      onClose={state.handleCloseTask}
    />

    {/* Outlives the task modal that started the run: the changes modal closes
        itself once the write lands, and a new company is submitted from a row
        that stays put. */}
    <AccessGrantResultsModal state={state.newCompanies.accessGrants} />
    <AccessGrantResultsModal state={state.changes.accessGrants} />
    {state.isReviewCardVisible ? (
      <HubspotSyncReviewCard
        state={state.review}
        companies={state.run.reviewCompanies}
        onClose={state.handleCloseTask}
      />
    ) : null}
  </>
)

export { HubspotSyncFlow }
